module.exports = __webpack_public_path__ + "img/official.fcbe2c1e.png";